"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var deepCopy = function deepCopy(o) {
  return JSON.parse((0, _stringify2.default)(o));
};
/**
 * Represents a Draft
 * @param {Object} course detail object
 * @param {Array.<Object>} sections list of section objects
 * @param {Array.<Object>} contents list of content objects
 * @param {Array.<Object>} contentModules list of content module objects
 */


var Draft = function Draft(draft) {
  (0, _classCallCheck3.default)(this, Draft);

  if (!draft) {
    return;
  }

  if (draft.course) {
    this.course = deepCopy(draft.course);
  }

  if (draft.sections) {
    this.sections = deepCopy(draft.sections);
  }

  if (draft.contents) {
    this.contents = deepCopy(draft.contents);
  }

  if (draft.contentModules) {
    this.contentModules = deepCopy(draft.contentModules);
  }
};

exports.default = Draft;